<template lang='pug'>
  .when-visible(ref="trigger")
    slot
</template>

<script lang='js'>
  export default {
    data() {
      return {
        visible: false,
        interval: 0
      }
    },

    mounted() {
      var self = this;
      this.interval = setInterval(() => {
        var elem = $(this.$refs.trigger);
        var win = $(window);
        var elementTop = elem.offset().top;
        var elementBottom = elementTop + elem.outerHeight();
        var viewportTop = win.scrollTop();
        var viewportBottom = viewportTop + win.height();
        var previousVisibility = this.visible;

        this.visible = elementBottom > viewportTop && elementTop < viewportBottom;

        if (this.visible) {
          this.$emit('visible');
          clearInterval(this.interval);
        }
      }, 300);
    },

    destroyed() {
      if (this.interval) {
        clearInterval(this.interval);
      }
    }
  }
</script>
